import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import ProviderTaskDetail from "../../components/providerPortal/ProviderTaskDetail";
import {
  fetchProviderTaskDetail,
  startProviderTask,
  completeProviderTask,
  uploadTaskPhoto,
  clearProviderTaskDetail,
} from "../../store/providerPortal/actions";
import * as types from "../../store/providerPortal/types";

const ProviderTaskDetailContainer = () => {
  const dispatch = useDispatch();
  const { id } = useParams();
  const {
    currentTask,
    startingTask,
    completingTask,
    uploadingPhoto,
    actionError,
  } = useSelector((state) => state.providerPortal);

  useEffect(() => {
    loadTask();

    return () => {
      dispatch(clearProviderTaskDetail());
    };
  }, [id]);

  const loadTask = () => {
    dispatch(fetchProviderTaskDetail(id)).payload.then(
      (response) => {
        dispatch({
          type: types.FETCH_PROVIDER_TASK_DETAIL_SUCCESS,
          payload: response.data,
        });
      },
      (error) => {
        dispatch({
          type: types.FETCH_PROVIDER_TASK_DETAIL_FAILURE,
          payload: error.response?.data || error.message,
        });
      }
    );
  };

  const handleStartTask = (taskId) => {
    return new Promise((resolve, reject) => {
      dispatch(startProviderTask(taskId)).payload.then(
        (response) => {
          dispatch({
            type: types.START_PROVIDER_TASK_SUCCESS,
            payload: response.data,
          });
          resolve(response.data);
        },
        (error) => {
          dispatch({
            type: types.START_PROVIDER_TASK_FAILURE,
            payload: error.response?.data || error.message,
          });
          reject(error);
        }
      );
    });
  };

  const handleCompleteTask = (taskId, data) => {
    return new Promise((resolve, reject) => {
      dispatch(completeProviderTask(taskId, data)).payload.then(
        (response) => {
          dispatch({
            type: types.COMPLETE_PROVIDER_TASK_SUCCESS,
            payload: response.data,
          });
          resolve(response.data);
        },
        (error) => {
          dispatch({
            type: types.COMPLETE_PROVIDER_TASK_FAILURE,
            payload: error.response?.data || error.message,
          });
          reject(error);
        }
      );
    });
  };

  const handleUploadPhoto = (taskId, formData) => {
    return new Promise((resolve, reject) => {
      dispatch(uploadTaskPhoto(taskId, formData)).payload.then(
        (response) => {
          dispatch({
            type: types.UPLOAD_TASK_PHOTO_SUCCESS,
            payload: response.data,
          });
          resolve(response.data);
        },
        (error) => {
          dispatch({
            type: types.UPLOAD_TASK_PHOTO_FAILURE,
            payload: error.response?.data || error.message,
          });
          reject(error);
        }
      );
    });
  };

  return (
    <ProviderTaskDetail
      task={currentTask.data}
      loading={currentTask.loading}
      error={currentTask.error}
      startingTask={startingTask}
      completingTask={completingTask}
      uploadingPhoto={uploadingPhoto}
      actionError={actionError}
      onStartTask={handleStartTask}
      onCompleteTask={handleCompleteTask}
      onUploadPhoto={handleUploadPhoto}
      onRefresh={loadTask}
    />
  );
};

export default ProviderTaskDetailContainer;
